import React, { ReactNode } from "react";
import styles from "./ErrorText.module.css";

interface ErrorTextProps {
  children: ReactNode;
  props?: Record<string, unknown>;
}

const ErrorText: React.FC<ErrorTextProps> = ({ children, ...props }) => {
  return (
    <span {...props} className={styles["error-text"]}>
      {children}
    </span>
  );
};

export default ErrorText;
